import { render } from "./WorkerConfig.vue?vue&type=template&id=134a12ee&scoped=true"
import script from "./WorkerConfig.vue?vue&type=script&lang=js"
export * from "./WorkerConfig.vue?vue&type=script&lang=js"

import "./WorkerConfig.vue?vue&type=style&index=0&id=134a12ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-134a12ee"]])

export default __exports__